var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.856 1.591l.046.012c.06.025.098.083.098.147v10.5A1.75 1.75 0 0119.25 14H1.75A1.75 1.75 0 010 12.25V1.75c0-.064.04-.12.098-.145a.157.157 0 01.175.034l5.425 5.425a.22.22 0 010 .31l-4.413 4.412a.656.656 0 00.928.929l4.412-4.413a.22.22 0 01.31 0L8.8 10.163c.94.94 2.462.94 3.402 0L14.065 8.3a.219.219 0 01.31 0l4.412 4.413a.656.656 0 10.928-.928l-4.413-4.413a.22.22 0 010-.31l5.425-5.425a.16.16 0 01.175-.034zM19.25 0c.084 0 .168.006.251.018a.437.437 0 01.246.743l-8.475 8.476a1.096 1.096 0 01-1.547 0L1.25.76a.437.437 0 01.246-.743A1.72 1.72 0 011.75 0z",
    fill: "#DAE3ED",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.17a3e1fa.svg";
export { ForwardRef as ReactComponent };